// Auto-generated file - DO NOT EDIT
// This file exports all icons from the mondial.ch assets package.

import MondialLogotypeWhiteRgb900pxW72ppi from "./mondial-logotype-white-rgb-900px-w-72ppi.png";
import MondialLogotypeWhiteRgb from "./mondial-logotype-white-rgb.svg";
import MondialLogotypeFullColorRgb900pxW72ppi from "./mondial-logotype-full-color-rgb-900px-w-72ppi.png";
import MondialLogotypeFullColorRgb from "./mondial-logotype-full-color-rgb.svg";
import MondialLogotypeBlackRgb from "./mondial-logotype-black-rgb.svg";
import MondialLogotypeBlackRgb900pxW72ppi from "./mondial-logotype-black-rgb-900px-w-72ppi.png";
import MondialLogoWhiteRgb900pxW72ppi from "./mondial-logo-white-rgb-900px-w-72ppi.png";
import MondialLogoWhiteRgb from "./mondial-logo-white-rgb.svg";
import MondialLogoMarkWhiteRgb from "./mondial-logo-mark-white-rgb.svg";
import MondialLogoMarkWhiteRgb900pxW72ppi from "./mondial-logo-mark-white-rgb-900px-w-72ppi.png";
import MondialLogoMarkBlackRgb from "./mondial-logo-mark-black-rgb.svg";
import MondialLogoMarkFullColorRgb900pxW72ppi from "./mondial-logo-mark-full-color-rgb-900px-w-72ppi.png";
import MondialLogoMarkFullColorRgb from "./mondial-logo-mark-full-color-rgb.svg";
import MondialLogoMarkBlackRgb900pxW72ppi from "./mondial-logo-mark-black-rgb-900px-w-72ppi.png";
import MondialLogoInvertedRgb from "./mondial-logo-inverted-rgb.svg";
import MondialLogoInvertedRgb900pxW72ppi from "./mondial-logo-inverted-rgb-900px-w-72ppi.png";
import MondialLogoFullColorRgb from "./mondial-logo-full-color-rgb.svg";
import MondialLogoFullColorRgb900pxW72ppi from "./mondial-logo-full-color-rgb-900px-w-72ppi.png";
import MondialLogoBlackRgb from "./mondial-logo-black-rgb.svg";
import MondialLogoBlackRgb900pxW72ppi from "./mondial-logo-black-rgb-900px-w-72ppi.png";

export const MondialIcons = {
  MondialLogotypeWhiteRgb900pxW72ppi,
  MondialLogotypeWhiteRgb,
  MondialLogotypeFullColorRgb900pxW72ppi,
  MondialLogotypeFullColorRgb,
  MondialLogotypeBlackRgb,
  MondialLogotypeBlackRgb900pxW72ppi,
  MondialLogoWhiteRgb900pxW72ppi,
  MondialLogoWhiteRgb,
  MondialLogoMarkWhiteRgb,
  MondialLogoMarkWhiteRgb900pxW72ppi,
  MondialLogoMarkBlackRgb,
  MondialLogoMarkFullColorRgb900pxW72ppi,
  MondialLogoMarkFullColorRgb,
  MondialLogoMarkBlackRgb900pxW72ppi,
  MondialLogoInvertedRgb,
  MondialLogoInvertedRgb900pxW72ppi,
  MondialLogoFullColorRgb,
  MondialLogoFullColorRgb900pxW72ppi,
  MondialLogoBlackRgb,
  MondialLogoBlackRgb900pxW72ppi,
};

export {
  MondialLogotypeWhiteRgb900pxW72ppi,
  MondialLogotypeWhiteRgb,
  MondialLogotypeFullColorRgb900pxW72ppi,
  MondialLogotypeFullColorRgb,
  MondialLogotypeBlackRgb,
  MondialLogotypeBlackRgb900pxW72ppi,
  MondialLogoWhiteRgb900pxW72ppi,
  MondialLogoWhiteRgb,
  MondialLogoMarkWhiteRgb,
  MondialLogoMarkWhiteRgb900pxW72ppi,
  MondialLogoMarkBlackRgb,
  MondialLogoMarkFullColorRgb900pxW72ppi,
  MondialLogoMarkFullColorRgb,
  MondialLogoMarkBlackRgb900pxW72ppi,
  MondialLogoInvertedRgb,
  MondialLogoInvertedRgb900pxW72ppi,
  MondialLogoFullColorRgb,
  MondialLogoFullColorRgb900pxW72ppi,
  MondialLogoBlackRgb,
  MondialLogoBlackRgb900pxW72ppi,
};
